/*
 * LUV ABOMINABLE PDP
 * - Gallery thumbnail click -> swap main image
 * - Color/size button click OR <select> change -> find matching variant,
 *   update hidden id input, ATC label/price, sold-out state, main image
 *
 * Product JSON is embedded in the PDP via <script type="application/json" data-lv-product-json>.
 *
 * 2026-09-10: options with 7+ values render as a native <select> (see main-product.liquid);
 * single-value options render no picker at all. Both are handled here without changing the
 * index-based matching from 2026-08-14.
 */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-lv-pdp]');
  if (!pdp) return;

  /* ---------- Gallery ---------- */
  var mainImg = pdp.querySelector('#lv-main-img');
  var thumbs = pdp.querySelectorAll('[data-lv-thumb]');

  function setMainImage(src, srcset) {
    if (!mainImg || !src) return;
    mainImg.setAttribute('src', src);
    if (srcset) mainImg.setAttribute('srcset', srcset);
    else mainImg.removeAttribute('srcset');
  }

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      var srcset = btn.getAttribute('data-srcset') || '';
      setMainImage(src, srcset);
      // Thumbnails are role="tab" — use aria-selected, not aria-pressed.
      thumbs.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    });
  });

  /* ---------- Variant selection ----------
   * 2026-08-14 REWRITE. Options are matched by INDEX, never by name.
   *
   * The previous version resolved a `colorIdx` by looking up the literal strings
   * "Color"/"Colour" in product.options. BOM BERLANDS names its options "Shoe size"
   * and "Shoe strings color", so colorIdx came back -1, findVariant() matched on
   * option1 alone, and every one of its 48 size x lace-colour combinations rendered
   * "Sold Out" on in-stock inventory ($500 SKU, 42+ variants unbuyable).
   *
   * Option names are now presentation only. Everything below keys off the option's
   * position, works for N options, and compares values as STRINGS so "8", "08",
   * "8.0" and "9.5" stay distinct and never get numerically coerced.
   */
  var productJsonEl = pdp.querySelector('[data-lv-product-json]');
  if (!productJsonEl) return;

  var product;
  try { product = JSON.parse(productJsonEl.textContent); }
  catch (e) { return; }
  if (!product || !product.variants || !product.variants.length) return;

  var hiddenId = pdp.querySelector('[data-lv-variant-id]');
  var atcBtn = pdp.querySelector('[data-lv-atc]');
  var atcLabel = pdp.querySelector('[data-lv-atc-label]');
  var priceEl = pdp.querySelector('[data-lv-price]');
  var stockEl = pdp.querySelector('[data-lv-stock-message]');
  var LOW_STOCK_THRESHOLD = 5;

  /* Liquid caps product.variants at 250. Past that the serialized set is INCOMPLETE:
   * a ?variant= deep link outside it would miss below, fall back to variants[0], and
   * repaint labels/price for the wrong variant while the hidden id still held the
   * deep-linked one -- with ATC enabled. So fail CLOSED: do not initialize variant
   * state at all. Liquid's server-rendered hidden id + ATC state are correct for the
   * landed variant, so that variant stays purchasable; only in-page switching is lost. */
  if (product.variants_truncated) {
    console.error('[lv-pdp] product.variants truncated at 250 (' + product.variants.length +
      ' serialized). Variant switching disabled -- needs a Section Rendering refactor.');
    pdp.querySelectorAll('[data-lv-opt-btn], [data-lv-color], [data-lv-size], [data-lv-opt-select]')
      .forEach(function (b) { b.setAttribute('disabled', ''); });
    var warn = document.createElement('p');
    warn.className = 'lv-stock-message lv-stock-soldout';
    warn.textContent = 'Too many variants to switch here — use the size/colour links.';
    var firstBlock = pdp.querySelector('[data-lv-opt-block], .lv-color-block, .lv-size-block');
    if (firstBlock && firstBlock.parentNode) firstBlock.parentNode.insertBefore(warn, firstBlock);
    return;
  }

  function sval(x) { return x === null || typeof x === 'undefined' ? null : String(x); }

  /* Option blocks, in DOM order. Prefer the index-driven markup; fall back to the
   * legacy classes so a half-deployed theme (new JS + old Liquid) still works.
   * A block is either a button grid or a single <select>; a single-value option has
   * NO block at all — its selection is seeded from the initial variant below. */
  var blocks = [].slice.call(pdp.querySelectorAll('[data-lv-opt-block]'));
  if (!blocks.length) {
    blocks = [].slice.call(pdp.querySelectorAll('.lv-color-block, .lv-size-block'));
  }
  var optBlocks = blocks.map(function (el, i) {
    var declared = el.getAttribute('data-lv-opt-index');
    return {
      el: el,
      index: declared === null ? i : parseInt(declared, 10),
      label: el.querySelector('[data-lv-selected-value], [data-lv-selected-color], [data-lv-selected-size]'),
      buttons: [].slice.call(el.querySelectorAll('button')),
      select: el.querySelector('select[data-lv-opt-select]')
    };
  });

  function btnValue(b) {
    return b.getAttribute('data-lv-value')
        || b.getAttribute('data-lv-color')
        || b.getAttribute('data-lv-size');
  }
  // <option>s carry an explicit value AND data-lv-value; availability suffixes live in the
  // option TEXT only, so reading the attribute (never the text) is always safe.
  function optValue(o) {
    var v = o.getAttribute('data-lv-value');
    return v !== null ? v : o.value;
  }

  var nOptions = (product.options || []).length ||
    optBlocks.reduce(function (m, b) { return Math.max(m, b.index + 1); }, 0);

  // Seed selection from the variant Liquid actually rendered into the form.
  var initialVariant = null;
  var initialId = hiddenId ? parseInt(hiddenId.value, 10) : 0;
  if (initialId) {
    initialVariant = product.variants.filter(function (v) { return v.id === initialId; })[0];
  }
  if (!initialVariant) initialVariant = product.variants[0];

  var selection = [];
  for (var i = 0; i < nOptions; i++) {
    selection[i] = sval(initialVariant['option' + (i + 1)]);
  }

  function moneyShort(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function findVariant() {
    return product.variants.filter(function (v) {
      for (var i = 0; i < nOptions; i++) {
        if (selection[i] === null) continue;
        if (sval(v['option' + (i + 1)]) !== selection[i]) return false;
      }
      return true;
    })[0];
  }

  /* `noMatch` distinguishes "this combination does not exist as a variant" from
   * "this variant exists and is sold out". Reporting a nonexistent combination as
   * Sold Out is what made the BERLANDS bug read as a stock problem. */
  function updateStockMessage(v, noMatch) {
    if (!stockEl) return;
    stockEl.className = 'lv-stock-message';
    if (noMatch) {
      stockEl.textContent = 'Not available in this combination';
      stockEl.classList.add('lv-stock-soldout');
      stockEl.removeAttribute('hidden');
      return;
    }
    if (!v || !v.available) {
      stockEl.textContent = 'Sold Out';
      stockEl.classList.add('lv-stock-soldout');
      stockEl.removeAttribute('hidden');
      return;
    }
    if (v.inventory_management && typeof v.inventory_quantity === 'number'
        && v.inventory_quantity > 0 && v.inventory_quantity <= LOW_STOCK_THRESHOLD) {
      stockEl.textContent = 'Almost gone · ' + v.inventory_quantity + ' left in this size';
      stockEl.classList.add('lv-stock-low');
      stockEl.removeAttribute('hidden');
      return;
    }
    stockEl.setAttribute('hidden', '');
    stockEl.textContent = '';
  }

  /* ---------- Image sizing helpers (2026-09-10) ----------
   * The gallery <img> carries a srcset + sizes, so the browser picks a candidate by the
   * rendered width x DPR. Warmups and variant swaps use the SAME rule instead of a fixed
   * 1200px, and never re-fetch the asset already on screen — the old fixed-width warmup
   * downloaded the LCP asset a second time at a width the browser had not chosen. */
  var LEAD_WIDTHS = [480, 800, 1200, 1600];
  function assetPath(u) { return String(u || '').split('?')[0]; }
  function neededWidth() {
    var w = 0;
    if (mainImg && mainImg.getBoundingClientRect) w = mainImg.getBoundingClientRect().width;
    if (!w) w = 600;
    var dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    return Math.ceil(w * dpr);
  }
  function pickWidth(need) {
    for (var i = 0; i < LEAD_WIDTHS.length; i++) if (LEAD_WIDTHS[i] >= need) return LEAD_WIDTHS[i];
    return LEAD_WIDTHS[LEAD_WIDTHS.length - 1];
  }
  function withWidth(src, w) {
    // CR-01: Shopify featured_image.src usually carries ?v=<bust>; never append "&width"
    // without a preceding "?".
    return src + (src.indexOf('?') === -1 ? '?width=' + w : '&width=' + w);
  }
  function pickFromSrcset(srcset, need) {
    var best = null, bestW = 0, largest = null, largestW = 0;
    String(srcset || '').split(',').forEach(function (part) {
      var m = part.trim().match(/^(\S+)\s+(\d+)w$/);
      if (!m) return;
      var w = parseInt(m[2], 10);
      if (w >= need && (best === null || w < bestW)) { best = m[1]; bestW = w; }
      if (w > largestW) { largest = m[1]; largestW = w; }
    });
    return best || largest;
  }

  function updateUiForVariant(v) {
    if (!v) {
      // No variant for this combination. Empty AND disable the hidden id so a
      // keyboard/no-JS submit cannot post the previously selected variant --
      // the old code left a stale id in the form.
      if (hiddenId) { hiddenId.value = ''; hiddenId.setAttribute('disabled', ''); }
      if (atcBtn) { atcBtn.setAttribute('disabled', ''); }
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      updateStockMessage(null, true);
      return;
    }
    if (hiddenId) { hiddenId.value = v.id; hiddenId.removeAttribute('disabled'); }
    if (priceEl) priceEl.textContent = moneyShort(v.price);
    if (atcBtn) {
      if (v.available) atcBtn.removeAttribute('disabled');
      else atcBtn.setAttribute('disabled', '');
    }
    if (atcLabel) {
      atcLabel.textContent = v.available
        ? ('Add to Bag · ' + moneyShort(v.price))
        : 'Sold Out';
    }
    updateStockMessage(v);
    // Swap main image if the variant has its own image
    if (v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src;
      var srcset = LEAD_WIDTHS.map(function (w) { return withWidth(src, w) + ' ' + w + 'w'; }).join(', ');
      setMainImage(withWidth(src, pickWidth(neededWidth())), srcset);
    }
  }

  /* Availability, recomputed per option index.
   *
   * A value at option i is offerable if SOME variant carries that value, agrees with
   * every OTHER currently-selected option, and is available. Two states are reported,
   * because they are not the same thing and the accessible name must not claim they are:
   *   - unavailable in EVERY combination      -> "(sold out)"
   *   - only unavailable with the current pick -> "(unavailable with current selection)"
   * The old code updated the class and data-available but never the aria-label, so a
   * screen reader kept announcing a stale "(sold out)" after the selection changed.
   * Struck buttons stay clickable (no pointer-events:none in lv-base.css), so any dead
   * end recovers in one click. <option>s are DISABLED instead (a select cannot show a
   * strikethrough); the currently selected option keeps its selection even when it
   * becomes disabled, and changing the other option re-enables it. */
  function availability(i, val) {
    var withCurrent = product.variants.some(function (v) {
      if (sval(v['option' + (i + 1)]) !== val) return false;
      for (var j = 0; j < nOptions; j++) {
        if (j === i || selection[j] === null) continue;
        if (sval(v['option' + (j + 1)]) !== selection[j]) return false;
      }
      return v.available;
    });
    var everAnywhere = product.variants.some(function (v) {
      return sval(v['option' + (i + 1)]) === val && v.available;
    });
    return { withCurrent: withCurrent, everAnywhere: everAnywhere };
  }

  function refreshOptionAvailability() {
    optBlocks.forEach(function (blk) {
      var i = blk.index;
      var name = (product.options && product.options[i]) || '';
      blk.buttons.forEach(function (b) {
        var val = sval(btnValue(b));
        var a = availability(i, val);
        b.classList.toggle('lv-opt-soldout', !a.withCurrent);
        b.setAttribute('data-available', a.withCurrent ? 'true' : 'false');
        var suffix = a.withCurrent ? ''
          : (a.everAnywhere ? ' (unavailable with current selection)' : ' (sold out)');
        b.setAttribute('aria-label', (name ? name + ' ' : '') + val + suffix);
      });
      if (blk.select) {
        [].slice.call(blk.select.options).forEach(function (o) {
          var val = sval(optValue(o));
          var a = availability(i, val);
          o.disabled = !a.withCurrent;
          o.setAttribute('data-available', a.withCurrent ? 'true' : 'false');
          o.textContent = val + (a.withCurrent ? '' : (a.everAnywhere ? ' (unavailable)' : ' (sold out)'));
        });
      }
    });
  }

  function applySelection(blk, val) {
    selection[blk.index] = val;
    if (blk.label) blk.label.textContent = val;   // block-scoped: no cross-block clobber
    blk.buttons.forEach(function (b) {
      b.setAttribute('aria-checked', sval(btnValue(b)) === val ? 'true' : 'false');
    });
    refreshOptionAvailability();
    updateUiForVariant(findVariant());
  }

  optBlocks.forEach(function (blk) {
    blk.buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applySelection(blk, sval(btnValue(btn)));
      });
    });
    if (blk.select) {
      blk.select.addEventListener('change', function () {
        var o = blk.select.options[blk.select.selectedIndex];
        if (!o) return;
        applySelection(blk, sval(optValue(o)));
      });
    }
  });

  // Seed availability state on first render
  refreshOptionAvailability();

  // Seed UI on initial render (in case Liquid defaults didn't already set things)
  updateUiForVariant(findVariant() || initialVariant);

  // Warm variant featured images AND every gallery thumbnail's full-size candidate so the
  // first colour switch + first thumb click are both instant (no network). Right-sized to
  // the candidate the browser would pick, and never the asset already on screen.
  (function preloadAllImages() {
    var seen = {};
    var shown = mainImg ? assetPath(mainImg.currentSrc || mainImg.src) : '';
    var need = neededWidth();
    function bump(src) {
      if (!src || seen[src] || assetPath(src) === shown) return;
      seen[src] = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    }
    product.variants.forEach(function (v) {
      if (v.featured_image && v.featured_image.src) {
        bump(withWidth(v.featured_image.src, pickWidth(need)));
      }
    });
    pdp.querySelectorAll('[data-lv-thumb]').forEach(function (t) {
      bump(pickFromSrcset(t.getAttribute('data-srcset'), need) || t.getAttribute('data-src'));
    });
  })();
})();
